// B2B Wholesale: Intercept checkout login link to redirect back to /cart after login
// This rewrites Shopify's injected checkout login URL to include return_to=/cart

(function () {

  // --- Part A: Rewrite checkout login links on the current page ---
  function rewriteLoginLinks() {
    document.querySelectorAll('a[href*="/customer_authentication/login"]').forEach(function (link) {
      var href = link.getAttribute('href');
      // Only rewrite if it doesn't already have our return_to
      if (href.indexOf('return_to') === -1) {
        // Append return_to=/cart
        var separator = href.indexOf('?') !== -1 ? '&' : '?';
        link.setAttribute('href', href + separator + 'return_to=' + encodeURIComponent('/cart'));
      }
    });
  }

  // Run on page load
  rewriteLoginLinks();

  // --- Part B: Re-run if Shopify's checkout JS injects the link dynamically ---
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      rewriteLoginLinks();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // --- Part C: Force cart recalculation after login redirect lands on /cart ---
  // Runs once per session when customer arrives at /cart after logging in
  if (window.location.pathname === '/cart' && window.__st && window.__st.cid) {
    // Customer is logged in and on cart page
    if (!sessionStorage.getItem('b2b_cart_refreshed')) {
      sessionStorage.setItem('b2b_cart_refreshed', '1');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_b2b_refresh': Date.now().toString() } })
      }).then(function () {
        window.location.reload();
      });
    }
  }

}());